import BellFilled from './BellFilled';
import BellOutlineThick from './BellOutlineThick';
import BellOutlineThin from './BellOutlineThin';

export default function NotifyMeBell({
  colour,
  height,
  variant,
  mode = 'light',
  width
}: {
  colour?: string;
  height?: number;
  mode?: 'light' | 'dark';
  variant: 'outline-thick' | 'outline-thin' | 'filled';
  width?: number;
}) {
  switch (variant) {
    case 'filled':
      return (
        <BellFilled
          fill={colour ? colour : mode === 'dark' ? '#D19FF4' : '#8907E7'}
          height={height ? height - 2 : 14}
          width={width ? width - 2 : 12}
        />
      );
    case 'outline-thick':
      return (
        <BellOutlineThick
          fill={colour ? colour : mode === 'dark' ? 'black' : 'white'}
          height={height ?? 14}
          width={width ?? 12}
        />
      );
    case 'outline-thin':
      return (
        <BellOutlineThin
          fill={colour ? colour : mode === 'dark' ? 'black' : 'white'}
          height={height ?? 20}
          width={width ?? 20}
        />
      );
  }
}
